<template>
    <rkm-area
        title="Classificação de risco / Vulnerabilidade *"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    :validations="validations.classificacaoRisco"
                    buttons
                    class="classificacao-risco"
                    name="Classificação de risco"
                    v-model="data.model.classificacaoRiscoId"
                >
                    <rkm-form-radio
                        v-for="classificacaoRisco in data.form.classificacoesRisco"
                        v-bind:key="classificacaoRisco.id"
                        :style="'color: ' + classificacaoRisco.cor"
                        :value="classificacaoRisco.id"
                    >
                        <span class="classificacao-risco-nome">
                            {{ encaminhamento ? classificacaoRisco.descricaoEncaminhamento : classificacaoRisco.nome }}
                        </span>
                    </rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                classificacaoRisco: {required: true},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
        encaminhamento: {type: Boolean, default: false},
    },
}
</script>

<style scoped>
.classificacao-risco .btn {
    border-radius: 3px;
    border: 1px solid rgb(166 169 175);
    height: auto;
    margin-right: 4px;
    padding: 1rem 1.5rem 1rem 50px;
    transition: border-color 0.3s;
}
.classificacao-risco .btn:before {
    background: currentColor;
    content: '';
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: opacity 0.3s;
    width: 100%;
}
.classificacao-risco .btn:after {
    border-radius: 100%;
    border: 3px solid #FFF;
    box-shadow: 0px 0px 0 2px rgb(166 169 175), 0px 0px 0 0px rgb(166 169 175);
    content: '';
    height: 15px;
    left: 20px;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    transition: box-shadow 0.3s, background 0.3s;
    width: 15px;
}
.classificacao-risco .btn span {
    display: block;
    line-height: 1;
    text-align: left;
}
.classificacao-risco-nome {
    color: #495057;
    font-size: 1.15em;
    font-weight: 400;
}
.classificacao-risco .btn:hover:after {
    box-shadow: 0px 0px 0 2px currentColor, 0px 0px 0px 0px currentColor;
}
.classificacao-risco .btn.active {
    border-color: currentColor;
    box-shadow: 0px 0px 0 0.5px currentColor, 0px 0px 15px -7px currentColor;
}
.classificacao-risco .btn.active:before {
    opacity: 0.15;
}
.classificacao-risco .btn.active:after {
    background: currentColor;
    box-shadow: 0px 0px 0 2px currentColor, 0px 0px 10px 0px currentColor;
}
</style>